import { lazy, Suspense } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';

import DashboardLayout from 'src/layouts/dashboard';

import ProtectedRoute from './components/ProtectedRoute';

export const IndexPage = lazy(() => import('src/pages/app'));
export const LocalizadorPage = lazy(() => import('src/pages/localizador'));
export const BarredoraPage = lazy(() => import('src/pages/barredora'));
export const BlogPage = lazy(() => import('src/pages/blog'));
export const UserPage = lazy(() => import('src/pages/user'));
export const LoginPage = lazy(() => import('src/pages/login'));
export const ProductsPage = lazy(() => import('src/pages/products'));
export const Page404 = lazy(() => import('src/pages/page-not-found'));

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/',
      element: (
        <ProtectedRoute element={<Navigate to="/localizador" />} />
      ),
    },
    {
      path: '/localizador',
      element: (
        <DashboardLayout>
          <Suspense>
            <ProtectedRoute element={<Outlet />} />
          </Suspense>
        </DashboardLayout>
      ),
      children: [
        { element: <LocalizadorPage />, index: true },
        { path: 'user', element: <UserPage /> },
        { path: 'products', element: <ProductsPage /> },
        { path: 'blog', element: <BlogPage /> },
      ],
    },
    {
      path: '/barredora',
      element: (
        <DashboardLayout>
          <Suspense>
            <ProtectedRoute element={<Outlet />} />
          </Suspense>
        </DashboardLayout>
      ),
      children: [
        { element: <BarredoraPage />, index: true },
        { path: 'user', element: <UserPage /> },
        { path: 'products', element: <ProductsPage /> },
        { path: 'blog', element: <BlogPage /> },
      ],
    },
    {
      path: '/localizador/login',
      element: <LoginPage />,
    },
    {
      path: '404',
      element: <Page404 />,
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
